// SEE `leads/filters.js`

// We are using text search in radioFilters - we should try to update all this logic in general so it isn't so confusing
export const checkBoxFilters = ['dealer', 'type'];
export const rangeFilters = ['createdAt'];
export const radioFilters = ['partialExternalId', 'page', 'sortBy'];
